import styled from "styled-components";

import { Info24px } from "@similarweb/icons";
import { colorsPalettes, setElevation } from "@similarweb/styles";
import { Tooltip } from "@similarweb/ui-components";
import { Box, Flex, Stack, Text } from "@similarweb/ui-components/foundations";

import type { HeatmapTopic } from "app/pages/market-research/api-client/topicsHeatmapAPI";

import { TopicHighlightRow } from "./TopicHighlightRow";

const PanelContainer = styled(Stack)`
    flex: 1 1 calc(50% - 8px);
    min-width: 0;
    border-radius: 6px;
    overflow: hidden;
    background: ${colorsPalettes.carbon[0]};
    ${setElevation("Z1")}
`;

const PanelBody = styled(Stack)`
    background: ${colorsPalettes.sky[100]};
`;

type TopicsHighlightPanelProps = {
    panelId: string;
    title: string;
    tooltip: string;
    topics: HeatmapTopic[];
};

export const TopicsHighlightPanel = ({ panelId, title, tooltip, topics }: TopicsHighlightPanelProps) => (
    <PanelContainer data-automation={`heatmap-highlight-panel-${panelId}`}>
        <Flex
            paddingX="24px"
            paddingY="20px"
            gap="8px"
            alignItems="center"
        >
            <Text
                fontVariant="h5_2"
                color={colorsPalettes.carbon[500]}
            >
                {title}
            </Text>
            <Tooltip
                content={tooltip}
                placement="top"
                role="label"
            >
                <Info24px
                    size="sm"
                    color={colorsPalettes.carbon[300]}
                />
            </Tooltip>
        </Flex>
        <Box
            height="1px"
            width="100%"
            background={colorsPalettes.carbon[100]}
        />
        <PanelBody
            gap="8px"
            padding="20px"
        >
            {topics.map((topic) => (
                <TopicHighlightRow
                    key={topic.name}
                    topic={topic}
                />
            ))}
        </PanelBody>
    </PanelContainer>
);
